module.exports = __webpack_public_path__ + "static/media/spinner.958ded59.gif";